import React, { FC, TableHTMLAttributes } from 'react'
import styles from './Table.module.scss'
import cx from 'classnames'

type TableProps = React.TableHTMLAttributes<HTMLTableElement> & {
  className?: string
}

export const Table: FC<TableProps> = (props) => {
  return (
    <table cellSpacing={0} {...props} className={cx(styles.table, props.className)}>
      {props.children}
    </table>
  )
}

Table.displayName = 'Table'
